import { render, staticRenderFns } from "./Parcerias.vue?vue&type=template&id=115d30f9&scoped=true&"
import script from "./Parcerias.vue?vue&type=script&lang=js&"
export * from "./Parcerias.vue?vue&type=script&lang=js&"
import style0 from "./Parcerias.vue?vue&type=style&index=0&id=115d30f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115d30f9",
  null
  
)

export default component.exports